export default "__VITE_ASSET__DtecWQYG__"